"use client";
import TypographyMontserrat from "../../TypographyMontserrat";
import { FloatingLabelInputField } from "../../Inputs/InputField";
import {
    BACKGROUND_SHADOW,
    MODAL_CONTAINER,
    MODAL_SUB_CONTAINER,
    MODAL_CONTENT_CONTAINER,
    MODAL_BODY,
    MODAL_HEADER,
    MODAL_FOOTER,
    CANCEL_BUTTON_CLASS,
    DEFAULT_VALUES,
    FIRST_NAME_FIELD,
    FIRST_NAME_TEXT,
    LAST_NAME_FIELD,
    LAST_NAME_TEXT,
} from "./constant";
import { LAZY } from "../../../../public/Constants/EnumConstants";
import { CancelIcon } from "../../../../public/Theme";
import Image from "next/image";
import { useForm } from "react-hook-form";
import NewPrimaryButton from "../../Buttons/NewPrimaryButton/NewPrimaryButton";
import { useEffect, useState } from "react";
import { useSession, signIn } from "next-auth/react";
import { toast } from "react-toastify";
import { updateAppleLoggedInUserInfo } from "../../../../lib/User/action";

const UserDetailsModal = ({}) => {
    const { data: session, update: updateSession } = useSession();
    const [showModal, setShowModal] = useState(false);
    const {
        handleSubmit,
        register,
        setError,
        formState: { errors },
        reset,
    } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
        defaultValues: DEFAULT_VALUES,
    });

    const onSubmit = async (data) => {
        toast.dismiss();
        const payload = {
            first_name: data?.first_name,
            last_name: data?.last_name,
            email: session?.user?.email,
        };

        const response = await updateAppleLoggedInUserInfo(payload);
        if (response?.status == 200) {
            const updatedSession = await updateSession({
                ...session,
                user: {
                    ...session?.user,
                    newSignup: false,
                },
            });

            toast.success("Added Name Successfully");
            localStorage.setItem("apple-name-modal", "true");
            setShowModal(false);
            return;
        }
        toast.error(response?.error);
    };

    useEffect(() => {
        if (
            session?.user?.newSignup == true &&
            session?.user?.provider == "apple" &&
            !localStorage.getItem("apple-name-modal")
        )
            return setShowModal(true);
    }, [session]);

    return (
        <>
            {showModal && <div className={BACKGROUND_SHADOW}></div>}
            {showModal && (
                <div className={MODAL_CONTAINER}>
                    <div className={MODAL_SUB_CONTAINER}>
                        <div className={MODAL_CONTENT_CONTAINER}>
                            <div
                                onClick={() => {
                                    localStorage.setItem(
                                        "apple-name-modal",
                                        "true"
                                    );
                                    setShowModal(!showModal);
                                }}
                                className={CANCEL_BUTTON_CLASS}
                            >
                                <Image
                                    width={24}
                                    height={24}
                                    src={CancelIcon}
                                    alt="Cancel Icon"
                                    loading={LAZY}
                                />
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={MODAL_HEADER}>
                                    <TypographyMontserrat
                                        text={"Welcome ! Just one last thing"}
                                        size={"2xl"}
                                        fontWeight={"semibold"}
                                    />
                                    <TypographyMontserrat
                                        customStyle={"max-w-96"}
                                        align={"center"}
                                        text={
                                            "We'd love to personalize your experience. Could you please share your name with us?"
                                        }
                                    />
                                </div>
                                <div className={MODAL_BODY}>
                                    <div className="flex flex-col gap-y-4 justify-items-center w-full   mt-3 md:mt-10 mb-5">
                                        <FloatingLabelInputField
                                            errors={errors}
                                            field={FIRST_NAME_FIELD}
                                            register={register}
                                            label={FIRST_NAME_TEXT}
                                        />
                                        <FloatingLabelInputField
                                            errors={errors}
                                            field={LAST_NAME_FIELD}
                                            register={register}
                                            label={LAST_NAME_TEXT}
                                        />
                                    </div>
                                </div>

                                <div className={MODAL_FOOTER}>
                                    <NewPrimaryButton
                                        type={"submit"}
                                        width={"full"}
                                        text={"Lets's GO"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default UserDetailsModal;
